<template lang="pug">
div
    ListItem
        ListItemMeta(:title='$t("accountInfo.plan.titleText")' ) 
            template(slot="description")
                p {{description}}
                h3
                    span {{ $t('accountInfo.plan.thisMonthBtnText') }} :
                    span(style="text-decoration: line-through;" v-if="currentChargeAmount!=''") {{separator(currentChargeAmount)}}
                    span(v-if="currentChargeAmount!=''") &emsp;
                    span {{separator(totalAmount.toFixed(3))}} USD
        template(slot="extra") 
            li
                Button.cardBtn(type="primary" @click="addData" v-if="!userInfoData.subscription" :disabled="!userInfoData.customerId") {{ $t('accountInfo.plan.selectPlanBtnText') }}
                div(v-else)
                    Row(type="flex" align="middle" justify="space-between") 
                        Button.cardBtn(type="primary" @click="showPaymentDetail") {{ $t('accountInfo.plan.thisMonthBtnText') }}
                        Button.cardBtn(type="primary" @click="editData") {{ $t('accountInfo.plan.changePlanBtnText') }}
                        div(v-if="invoiceData.length>0")
                            Button.cardBtn(type="primary" :loading="payInvoiceLoading" @click="payInvoice")  
                                span(v-if="!payInvoiceLoading") {{ $t('accountInfo.plan.payPlanBtnText') }}
                                span(v-else) Loading...
                
    Modal(v-model="isOpened" :title="modalTitle" @on-cancel="closeModalEvent" footer-hide width="805")
        template(v-if="!showPlanDetail&&actionType!=='showPaymentDetail'")
            Card.planCard(v-for="plan in planItems" :key="plan.id" dis-hover v-on:click.native="clickedPlan(plan)" :class="cardPointerClass(selectedPlanId == plan.id)")
                Row(type="flex" align="middle" justify="space-between") 
                    Col(span="2" style="margin-left: -30px"  flex="40px")
                        Icon(type='md-checkmark-circle' size="28" color="#00c08b" v-if="selectedPlanId == plan.id")
                    Col.textAlignLeft.planName(span="6" v-if="plan.product.metadata")
                        p.currentPlan(v-if="userInfoData.subscription!==undefined && userInfoData.subscription.priceId == plan.id") {{ $t('accountInfo.plan.nowPlanText') }}
                        h2 {{ $t('accountInfo.'+plan.product.metadata.resourceName) }}
                    Col.textAlignRight(span="16" v-if="plan.currency && plan.recurring")
                        h4.planPrice {{((plan.unit_amount_decimal/100)*30).toFixed(1)}}  {{plan.currency.toUpperCase()}} / {{plan.recurring.interval}}
            template(v-if="isRouterAlive")
                cost-usage-preview-bar(
                    :currentCost="costUsagePlanData.currentCost"
                    :estimateCost="costUsagePlanData.estimateCost"
                    :subscriptionPeriodStart="getSubscriptionPeriodStart"
                    :chartHeight="50"
                )
            template
                Divider
                Card.planCard(dis-hover v-if="showChangePlanDetail")
                    p(slot="title") {{ $t('accountInfo.plan.approximateCostText') }}
                    p(v-if="differencePriceData.length == 0") {{ $t('accountInfo.noDataText') }}
                    div(v-for="item in differencePriceData" :key="item.id")
                        //- p {{item.id}}
                        Table(v-if="item.id == selectedPlanId" height="300" :columns="differencePriceColumns" :data="item.data" show-summary :summary-method="handleSummary" :disabled-hover="true")
                            template(slot-scope="{row}" slot="unit_amount")
                                //- span $ {{row.unit_amount}} USD
                                span(v-if="row.amount == 0") $ 0 USD
                                span(v-else) $ {{separator(row.unit_amount)}} USD
                            template(slot-scope="{row}" slot="qty")
                                span {{row.daysUntilEndOfMonth}} Day
                                //- span $ {{row.qty}} Day
                                //- div(v-if="row.qty == 0 || row.resourceType == 'Plan'")
                                //-     span {{row.qty}}
                                //- div(v-else)
                                //-     span(style="text-decoration: line-through;") {{row.qty}} 
                                //-     span &emsp;
                                //-     span(v-if="row.up_to*row.useDate - row.qty>0") 0
                                //-     span(v-else) {{row.qty-row.up_to*row.useDate}}
                            template(slot-scope="{row}" slot="amount")
                                span $ {{separator(row.amount)}} USD
            
        template(v-if="showPlanDetail")
            div(style="display: flex;justify-content: center")
                p(v-if="planData.length == 0") {{ $t('accountInfo.noDataText') }}
                Table(v-else height="500" :columns="planColumns" :data="planData" width="780" :disabled-hover="true")
                    template(slot-scope="{ row }" slot="basicUsage")
                        Icon(type="md-checkmark" color="green" size="24" v-if="row.basicUsage == true&&typeof row.basicUsage == 'boolean'")
                        Icon(type="md-close" color="red" size="24" v-if="row.basicUsage == false&&typeof row.basicUsage == 'boolean'")
                        span(v-if="typeof row.basicUsage !== 'boolean'") {{row.basicUsage}}
                        Tooltip(:content="row.basicContent" placement="right" max-width="300" v-if="row.basicContent")
                            Icon(type="ios-help-circle-outline" color="green" size="20" v-if="typeof row.basicUsage == 'number'")

                    template(slot-scope="{ row }" slot="proUsage")
                        Icon(type="md-checkmark" color="green" size="24" v-if="row.proUsage == true&&typeof row.proUsage == 'boolean'")
                        Icon(type="md-close" color="red" size="24" v-if="row.proUsage == false&&typeof row.proUsage == 'boolean'")
                        span(v-if="typeof row.proUsage !== 'boolean'") {{row.proUsage}}
                        Tooltip(:content="row.proContent" placement="right" max-width="300" v-if="row.proContent")
                            Icon(type="ios-help-circle-outline" color="green" size="20" v-if="typeof row.proUsage == 'number'")

                    template(slot-scope="{ row }" slot="enterpriseUsage")
                        Icon(type="md-checkmark" color="green" size="24" v-if="row.enterpriseUsage == true&&typeof row.enterpriseUsage == 'boolean'")
                        Icon(type="md-close" color="red" size="24" v-if="row.enterpriseUsage == false&&typeof row.enterpriseUsage == 'boolean'")
                        span(v-if="typeof row.enterpriseUsage !== 'boolean'") {{row.enterpriseUsage}}
                
                        
            div(style="display: flex; flex-direction: row; align-items: center; justify-content: center;margin-top: 20px")
                Button.cardBtn(type="primary" @click="action = 'showPaymentDetail' ; showPlanDetail = false" v-if="actionType == 'showPaymentDetail'") {{ $t('accountInfo.plan.goBackBtnText') }}
                Button.cardBtn(type="primary" @click="action = 'add' ; showPlanDetail = false" v-else) {{ $t('accountInfo.plan.goBackBtnText') }}


        // Card(v-if="actionType == 'showPaymentDetail'&&!showPlanDetail")
        div(v-if="actionType == 'showPaymentDetail'&&!showPlanDetail")
            p(v-if="paymentData.length == 0") {{ $t('accountInfo.noDataText') }}
            div(v-else)
                cost-usage-preview-bar(
                    :currentCost="costUsageData.currentCost"
                    :estimateCost="costUsageData.estimateCost"
                    :subscriptionPeriodStart="getSubscriptionPeriodStart"
                    :chartHeight="50"
                )
                Tabs( type="card"  )
                    TabPane(v-for="item in paymentData" :key="item.subscriptionId" :label='$t("accountInfo."+item.resourceName)')
                        Table( max-height="500" :columns="paymentColumns" :data="item.currentCharge.cost" show-summary :summary-method="handleCurrentAmount" :loading="tableLoading" :disabled-hover="true")
                            template(slot-scope="{row}" slot="price")
                                span(v-if='typeof row.itemUnit == "object"')
                                    Tooltip(placement="right" max-width="300")
                                        Icon(type="ios-help-circle-outline" color="green" size="20")
                                        template(slot="content") 
                                            div(v-for="itemUnit in row.itemUnit" :key="itemUnit.up_to")
                                                span {{'QTY <= '}}
                                                span(v-if="itemUnit.up_to") {{separator(parseInt(itemUnit.up_to))}}
                                                span(v-else) {{'∞'}}
                                                span &emsp;
                                                span $ {{separator(itemUnit.unit_amount_decimal)}} 
                                span(v-else)
                                    span $ {{separator(row.itemUnit)}}
                            template(slot-scope="{row,index}" slot="qty")
                                div(v-if="row.up_to == 0 || row.quantity ==0")
                                    span {{row.quantity}}
                                div(v-else)
                                    span(style="text-decoration: line-through;") {{separator(row.quantity)}} 
                                    span &emsp;
                                    span(v-if="row.quantity-row.up_to<=0") 0
                                    span(v-else) {{separator(row.quantity-row.up_to)}}
                            template(slot-scope="{ row }" slot="total")
                                span $ {{separator(row.totalPrice)}} USD

        .paymentModalFooter(v-if="!showPlanDetail")
            template(v-if="actionType == 'showPaymentDetail'")
                div
                    p {{ $t('accountInfo.plan.nowPlanText') }}: {{ $t('accountInfo.'+userInfoData.subscription.plan) }}
                    p(v-if="total_discount_amounts.name" style="font-style: red;color: red;font-weight: bold;font-size: 15px;") {{ $t('accountInfo.coupon.couponText') }}: {{ total_discount_amounts.name }} ({{total_discount_amounts.description}})
                    // p {{ $t('accountInfo.plan.moreComparisonsText') }} 
                    //     span.linkBtn(@click="action = 'showPlanDetail';showPlanDetail = true") {{ $t('accountInfo.plan.moreComparisonsBtnText') }} 
                    //     |{{ $t('accountInfo.plan.checkText') }}
                div 
                    div 
                        h4 {{ $t('accountInfo.plan.estimatedCostText') }}≈ $ {{separator(estimateAmount.toFixed(3))}} USD 
                            Tooltip(:content="estimateContent" placement="right" max-width="290" )
                                Icon(type="ios-help-circle-outline" color="green" size="20")
                div
                    Button.cardBtn(type="primary" @click="closeModalEvent") {{ $t('accountInfo.closeBtnText') }}
            template(v-else)
                div
                    p {{ $t('accountInfo.plan.descriptionOneText') }}
                    p {{ $t('accountInfo.plan.descriptionTwoText') }}
                    h3 
                        span.linkBtn(@click="action = 'showPlanDetail';showPlanDetail = true") {{ $t('accountInfo.plan.planCompareText') }} 
                    // p {{ $t('accountInfo.plan.moreComparisonsText') }} 
                    //     span.linkBtn(@click="action = 'showPlanDetail';showPlanDetail = true") {{ $t('accountInfo.plan.moreComparisonsBtnText') }} 
                    //     |{{ $t('accountInfo.plan.checkText') }}

                // div 
                //     h3 
                //         span.linkBtn(@click="action = 'showPlanDetail';showPlanDetail = true") 方案比較
                div
                    Button.cardBtn(@click="closeModalEvent") {{ $t('accountInfo.cancelBtnText') }}
                    Button.cardBtn(type="primary" :loading="isSafePlanLoading" @click="updatePlan") {{ $t('accountInfo.saveBtnText') }}

</template>

<script>
import {
    _getPrices,
    _createSubscribe,
    _updateSubscribe,
    _getAmount,
    _getSubscriptions,
    _getCalculateUsageSummary,
    _getDifferencePrice,
    _payInvoice,
} from "@/api/billing";

import { getEsData } from "@/api/esdata";

import moment from "moment";

import PaymentObjectTabs from "@/components/PaymentObjectTabs";
import PaymentCertTabs from "@/components/PaymentCertTabs";
import Vue from "vue";
Vue.component("PaymentObjectTabs", PaymentObjectTabs);
Vue.component("PaymentCertTabs", PaymentCertTabs);

import CostUsagePreviewBar from "@/components/Payment/CostUsagePreviewBar";

export default {
    name: "PlanListItem",
    components: {
        CostUsagePreviewBar,
    },
    props: ["userInfoData", "invoiceData", "total_discount_amounts"],
    data() {
        return {
            tableLoading: false,
            isOpened: false,
            selectedPlan: {},
            planItems: [],
            showPlanDetail: false,
            validateRule: {},
            data: {},
            planColumns: [
                {
                    title: "#",
                    key: "object",
                    tree: true,
                },
                {
                    title: this.$t("accountInfo.basic"),
                    key: "basicUsage",
                    slot: "basicUsage",
                },
                {
                    title: this.$t("accountInfo.pro"),
                    key: "proUsage",
                    slot: "proUsage",
                },
                {
                    title: "Enterprise",
                    key: "enterpriseUsage",
                    slot: "enterpriseUsage",
                },
            ],
            planData: [
                {
                    object: "平台資源",
                    basicUsage: "",
                    proUsage: "",
                    enterpriseUsage: "",
                },
                {
                    object: "App Profiles",
                    basicUsage: 3,
                    proUsage: 20,
                    enterpriseUsage: "Unlimited",
                },
                {
                    object: "FQDNConfig",
                    basicUsage: 10,
                    proUsage: 100,
                    enterpriseUsage: "Unlimited",
                },
                // {
                //     object: "FQDNConfig (1$)",
                //     basicUsage: 10,
                //     proUsage: 50,
                //     enterpriseUsage: "Unlimited"
                // },
                // {
                //     object: "FQDNConfig (0.2$)",
                //     basicUsage: 50,
                //     proUsage: 250,
                //     enterpriseUsage: "Unlimited"
                // },
                {
                    object: "WAF Rules",
                    basicUsage: 5,
                    proUsage: 30,
                    enterpriseUsage: "Unlimited",
                },
                {
                    object: "HTML Pages",
                    basicUsage: 3,
                    proUsage: 15,
                    enterpriseUsage: "Unlimited",
                },
                {
                    object: "Origin Policies",
                    basicUsage: 3,
                    proUsage: 15,
                    enterpriseUsage: "Unlimited",
                },
                {
                    object: "Sites",
                    basicUsage: 2,
                    proUsage: 12,
                    enterpriseUsage: "Unlimited",
                },
                {
                    object: "SLBs",
                    basicUsage: 2,
                    proUsage: 12,
                    enterpriseUsage: "Unlimited",
                },
                {
                    object: "EDGEs",
                    basicUsage: 2,
                    proUsage: 12,
                    enterpriseUsage: "Unlimited",
                },
                {
                    object: "Users",
                    basicUsage: 3,
                    proUsage: 15,
                    enterpriseUsage: "Unlimited",
                },
                {
                    object: "CDN Request Count",
                    basicUsage: 50000,
                    proUsage: 1000000,
                    enterpriseUsage: "Unlimited",
                },
                {
                    object: "平台客製化設定",
                    basicUsage: "",
                    proUsage: "",
                    enterpriseUsage: "",
                },
                {
                    object: "平台管理域名設定",
                    basicUsage: true,
                    proUsage: true,
                    enterpriseUsage: true,
                },
                {
                    object: "平台登入頁面設計",
                    basicUsage: true,
                    proUsage: true,
                    enterpriseUsage: true,
                },
                {
                    object: "平台Logo與Favicon",
                    basicUsage: true,
                    proUsage: true,
                    enterpriseUsage: true,
                },
                {
                    object: "平台主題樣式設計",
                    basicUsage: true,
                    proUsage: true,
                    enterpriseUsage: true,
                },
                {
                    object: "平台自訂目錄排版",
                    basicUsage: false,
                    proUsage: false,
                    enterpriseUsage: true,
                },
                {
                    object: "平台表單內容設計",
                    basicUsage: false,
                    proUsage: false,
                    enterpriseUsage: true,
                },
                {
                    object: "平台多語言管理",
                    basicUsage: false,
                    proUsage: false,
                    enterpriseUsage: true,
                },
                {
                    object: "平台圖片管理",
                    basicUsage: false,
                    proUsage: false,
                    enterpriseUsage: true,
                },
                {
                    object: "CDN CNAME 域名設定",
                    basicUsage: false,
                    proUsage: false,
                    enterpriseUsage: true,
                },
                {
                    object: "多群組管理",
                    basicUsage: "",
                    proUsage: "",
                    enterpriseUsage: "",
                },
                {
                    object: "多群組管理",
                    basicUsage: false,
                    proUsage: false,
                    enterpriseUsage: true,
                },
                {
                    object: "角色權限管理",
                    basicUsage: false,
                    proUsage: false,
                    enterpriseUsage: true,
                },
                {
                    object: "群組 WAF 管理",
                    basicUsage: false,
                    proUsage: false,
                    enterpriseUsage: true,
                },
                {
                    object: "更多功能",
                    basicUsage: "",
                    proUsage: "",
                    enterpriseUsage: "",
                },
                {
                    object: "即時流量檢視",
                    basicUsage: true,
                    proUsage: true,
                    enterpriseUsage: true,
                },
                {
                    object: "回源延遲監控",
                    basicUsage: true,
                    proUsage: true,
                    enterpriseUsage: true,
                },
                {
                    object: "BOT人機驗證",
                    basicUsage: true,
                    proUsage: true,
                    enterpriseUsage: true,
                },
                {
                    object: "用戶邀請",
                    basicUsage: true,
                    proUsage: true,
                    enterpriseUsage: true,
                },
                {
                    object: "批量操作",
                    basicUsage: true,
                    proUsage: true,
                    enterpriseUsage: true,
                },
                {
                    object: "API操作",
                    basicUsage: true,
                    proUsage: true,
                    enterpriseUsage: true,
                },
                {
                    object: "第三方Api Key設定",
                    basicUsage: false,
                    proUsage: false,
                    enterpriseUsage: true,
                },
                {
                    object: "CDN 防禦模式",
                    basicUsage: false,
                    proUsage: false,
                    enterpriseUsage: true,
                },
                {
                    object: "多群組管理",
                    basicUsage: "",
                    proUsage: "",
                    enterpriseUsage: "",
                },
                {
                    object: "多群組管理",
                    basicUsage: false,
                    proUsage: false,
                    enterpriseUsage: true,
                },
                {
                    object: "角色權限管理",
                    basicUsage: false,
                    proUsage: false,
                    enterpriseUsage: true,
                },
                {
                    object: "群組 WAF 管理",
                    basicUsage: false,
                    proUsage: false,
                    enterpriseUsage: true,
                },
            ],
            paymentColumns: [
                {
                    type: "expand",
                    width: 50,
                    render: (h, params) => {
                        let data = this.historyData.filter((e) => {
                            e.to = moment(e.to).format("YYYY-MM-DD");
                            e.from = moment(e.from).format("YYYY-MM-DD");
                            return e.subscriptionItemId === params.row.subscriptionItemId;
                        });

                        let userItmeLogData = this.userItmeLogData.filter((e) => {
                            e.recordDate = moment(e.recordDate).format("YYYY-MM-DD");
                            return e.subscriptionItemId === params.row.subscriptionItemId;
                        });

                        let userItmeLogObj = [];
                        userItmeLogData.forEach((e) => {
                            let items = [];
                            e.recordItems.forEach((item) => {
                                items.push({
                                    ItemName: item.itemName,
                                });
                            });
                            userItmeLogObj.push({
                                recordDate: e.recordDate,
                                useDay: e.recordUsageCount,
                                up_to: e.up_to,
                                items,
                            });
                        });

                        // return h("Table", {
                        //     props: {
                        //         columns: [
                        //             { title: "ItemName", align: "center", key: "itemName" },
                        //             { title: "StartDate", align: "center", key: "from" },
                        //             { title: "EndDate", align: "center", key: "to" },
                        //             { title: "UseDay", align: "center", key: "days" }
                        //         ], //表头
                        //         data //内部表格展示的数据
                        //     }
                        // });

                        let tabs = "PaymentObjectTabs";
                        if (
                            params.row.subscriptionName == "Cert_Sectigo" ||
                            params.row.subscriptionName == "Cert_Zerossl"
                        ) {
                            tabs = "PaymentCertTabs";
                            let certData = [];
                            userItmeLogObj.forEach((e) => {
                                let items = e.items;
                                let recordDate = e.recordDate;
                                items.forEach((item) => {
                                    let newCertData = certData.map(
                                        (certDate) => certDate.from + "-" + certDate.itemName
                                    );
                                    if (!newCertData.includes(recordDate + "-" + item.ItemName)) {
                                        certData.push({
                                            from: recordDate,
                                            itemName: item.ItemName,
                                        });
                                    }
                                });
                            });
                            data = certData;
                        }

                        const Tabs = h(tabs, {
                            props: {
                                objData: data,
                                userItmeLogObj,
                                itemName: params.row.subscriptionName,
                                itemId: params.row.subscriptionItemId,
                            },
                        });

                        return h("div", [Tabs]);
                    },
                },
                {
                    title: "ItemName",
                    key: "subscriptionName",
                },
                //- {
                //-     title: "付款內容",
                //-     key: "object"
                //- },
                {
                    title: "Price(Unit per day)",
                    key: "itemUnit",
                    slot: "price",
                },
                {
                    title: "Qty (day x Qty)",
                    key: "quantity",
                    slot: "qty",
                    width: 220,
                },
                {
                    title: "Total",
                    key: "totalPrice",
                    slot: "total",
                },
            ],
            paymentData: [
                //- {
                //-     subscriptionItem: "4 × BASIC_PLAN_METERED (at $0.50 / month)",
                //-     subscriptionItemId: "si_M6RblsKnWk3xBF",
                //-     currentQuantity: 0,
                //-     totalPrice: 2,
                //-     subscriptionName: "Plan",
                //-     itemUnit: 0.5,
                //-     quantity: 4
                //- }
            ],
            action: "",
            actionType: "add",
            selectedPlanId: "",
            historyData: [],
            estimateAmount: 0,
            estimateContent: "",
            showChangePlanDetail: true,
            differencePriceData: [],
            differencePriceColumns: [
                {
                    title: "Item",
                    align: "center",
                    key: "resourceType",
                },
                {
                    title: "Price",
                    align: "center",
                    key: "unit_amount",
                    slot: "unit_amount",
                },
                {
                    title: "Qty",
                    align: "center",
                    key: "qty",
                    slot: "qty",
                },
                {
                    title: "Total",
                    align: "center",
                    key: "amount",
                    slot: "amount",
                },
            ],
            payInvoiceLoading: false,
            isSafePlanLoading: false,
            planInfoQuery: {
                isFuzzySearch: false,
                esIndex: "rcm-payment-info",
                from: 0,
                sort: [],
                filters: [
                    {
                        key: "id",
                        type: "string",
                        value: "plan",
                    },
                ],
                _source: ["planColumns", "planData"],
            },
            paymentConfigs: [],
            userItmeLogData: [],
            costUsageData: {
                currentCost: 0,
                estimateCost: 0,
            },
            costUsagePlanData: {
                currentCost: 0,
                estimateCost: 0,
            },
            isRouterAlive: true,
            totalAmount: 0,
            currentChargeAmount: "",
        };
    },
    methods: {
        closeModalEvent() {
            this.isOpened = false;
            if (this.actionType == "showPaymentDetail") {
                this.action = "showPaymentDetail";
            } else {
                this.action = "add";
            }
            this.setDefaultValue();
            this.showPlanDetail = false;
        },
        clickedPlan(plan) {
            // this.$refs.listItem.reloadRouterView();
            this.selectedPlan = plan;
            this.selectedPlanId = plan.id;
            //show change plan amount
            this.showChangePlanDetail = true;
        },
        cardPointerClass(isActive) {
            return isActive ? "cardPointer cardPointer-active" : "cardPointer";
        },
        async updatePlan() {
            this.isSafePlanLoading = true;
            if (!this.$store.getters.getUserPaymentInfo.cardId) {
                this.$Notice.warning({
                    title: this.$t("accountInfo.plan.messageText.cardText"),
                    desc: ``,
                });
                this.closeModalEvent();
            } else {
                // update plan
                if (this.actionType == "add") {
                    await this.newSubscription();
                }
                if (this.actionType == "edit") {
                    await this.updateSubscription();
                    // await this.getSubscription();
                }
            }
            this.isSafePlanLoading = false;
        },
        async getSubscription() {
            let result = await _getSubscriptions({
                groupName: this.$store.state.queryGroupName,
                customerId: this.userInfoData.customerId,
            });
            return result.data.data.subscriptions;
        },
        async newSubscription() {
            await _createSubscribe({
                groupName: this.$store.state.queryGroupName,
                customerId: this.userInfoData.customerId,
                priceId: this.selectedPlanId,
                resourceName: this.selectedPlan.metadata.resourceName,
            })
                .then((result) => {
                    if (result.data.success) {
                        this.$emit("reloadUserInfoData");
                        this.$Message.success(this.$t("global.success"));
                        this.$store.commit("SET_USER_HAS_SUBSCRIPTION", true);
                    } else {
                        this.$Notice.warning({
                            title: this.$t("global.error"),
                            desc: `${result.data.message}`,
                        });
                    }
                    this.isOpened = false;
                })
                .catch((err) => {
                    this.$Notice.warning({
                        title: this.$t("global.error"),
                        desc: `${err}`,
                    });
                });
        },
        async updateSubscription() {
            if (!this.userInfoData.paymentStatus) {
                this.$Notice.warning({
                    title: this.$t("accountInfo.plan.messageText.payOffText"),
                    desc: ``,
                });
                this.closeModalEvent();
            } else if (this.selectedPlan.id && this.selectedPlan.id != this.userInfoData.subscription.priceId) {
                let subscription = await this.getSubscription();
                if (subscription.data.length < 2) {
                    await this.newSubscription();
                }

                await _updateSubscribe({
                    groupName: this.$store.state.queryGroupName,
                    customerId: this.userInfoData.customerId,
                    priceId: this.selectedPlan.id,
                })
                    .then((result) => {
                        this.$emit("reloadUserInfoData");
                        this.$Message.success(this.$t("global.success"));
                        this.isOpened = false;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$Notice.warning({
                            title: this.$t("global.error"),
                            desc: `${err}`,
                        });
                    });
            } else {
                this.$Notice.warning({
                    title: this.$t("global.error"),
                    desc: this.$t("accountInfo.plan.messageText.samePlanText"),
                });
            }
        },
        async getPlanItems() {
            let planItems = await _getPrices({ groupName: this.$store.state.queryGroupName });
            this.planItems = planItems.data.data.prices.data.filter((e) => {
                return e.product.metadata.resourceType == "Plan" && e.product.default_price == e.id;
            });
            this.planItems.sort(() => {
                return -1;
                // 為了讓元素不置換我們先回傳0
            });
            this.setDefaultValue();
        },
        setDefaultValue() {
            this.selectedPlan = !this.userInfoData.subscription ? this.planItems[0] : this.userInfoData.subscription;
            this.selectedPlanId = !this.userInfoData.subscription
                ? this.planItems[0].id
                : this.userInfoData.subscription.priceId;
        },
        addData() {
            this.isOpened = true;
            this.actionType = "add";
        },
        editData() {
            this.isOpened = true;
            this.actionType = "edit";
        },
        showPaymentDetail() {
            this.isOpened = true;
            this.actionType = "showPaymentDetail";
        },
        async getAmount() {
            if (this.userInfoData.subscription) {
                let subscriptionId = this.userInfoData.subscription.subscriptionId;
                let paymentData = await _getAmount({ groupName: this.$store.state.queryGroupName });
                this.paymentData = paymentData.data.data;
                this.paymentData.forEach((e) => {
                    this.estimateAmount += parseFloat(e.currentCharge.amount);
                    this.totalAmount += parseFloat(e.currentCharge.amount);
                    this.costUsageData.currentCost += parseFloat(e.currentCharge.amount);
                    this.costUsagePlanData.currentCost += parseFloat(e.currentCharge.amount);

                    let currentChargeCost = e.currentCharge.cost.find((item) => item.subscriptionName == "Plan");
                    let currentChargeAmount = e.currentCharge.amount;
                    let estimateChargeCost = e.estimateCharge.cost.find((item) => item.subscriptionName == "Plan");
                    let estimateChargeAmount = e.estimateCharge.amount;
                    let currentChargeText = `${this.$t("accountInfo." + e.resourceName)} ${this.$t(
                        "accountInfo.plan.currentContentText"
                    )}(${currentChargeCost.quantity}${this.$t("accountInfo.trialPeriodUnitText")}) :$ ${this.separator(
                        currentChargeAmount
                    )} USD \n`;
                    let estimateChargeText = `${this.$t("accountInfo.plan.estimateContentText")}(${
                        estimateChargeCost.quantity
                    }${this.$t("accountInfo.trialPeriodUnitText")}) :$ ${this.separator(estimateChargeAmount)} USD \n`;
                    this.estimateContent += currentChargeText;
                    if (subscriptionId == e.subscriptionId) {
                        this.estimateContent += estimateChargeText;
                        this.estimateAmount += parseFloat(e.estimateCharge.amount);
                        this.costUsageData.estimateCost += parseFloat(e.estimateCharge.amount);
                        this.costUsagePlanData.estimateCost += parseFloat(e.estimateCharge.amount);
                    }
                    if (e.total_discount_amounts) {
                        this.$emit("reloadDiscountData", e.total_discount_amounts);
                        let total_discount_amounts = e.total_discount_amounts;
                        this.estimateContent +=
                            total_discount_amounts.name + "(" + total_discount_amounts.description + ")";
                        if (total_discount_amounts.amount_off) {
                            if (this.estimateAmount > total_discount_amounts.amount_off) {
                                this.estimateAmount -= total_discount_amounts.amount_off;
                            } else {
                                this.estimateAmount = 0;
                            }
                            if (this.totalAmount > total_discount_amounts.amount_off) {
                                this.totalAmount -= total_discount_amounts.amount_off;
                            } else {
                                this.totalAmount = 0;
                            }
                        } else {
                            this.estimateAmount =
                                this.estimateAmount * (100 - total_discount_amounts.percent_off) * 0.01;
                            this.totalAmount = this.totalAmount * (100 - total_discount_amounts.percent_off) * 0.01;
                        }
                        if (currentChargeAmount > 0) {
                            this.currentChargeAmount = currentChargeAmount;
                        }
                    }
                });
            }
            this.tableLoading = false;
        },
        async getHistoryData() {
            let firstDate = moment().format("YYYY-MM-01");
            let lastDate = moment().endOf("month").format("YYYY-MM-DD");

            await _getCalculateUsageSummary({
                groupName: this.$store.state.queryGroupName,
                firstDate,
                lastDate,
            })
                .then((result) => {
                    this.historyData = result.data.data.UsageSummary.summary;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async getDifferencePriceData() {
            let subscriptionId = null;
            if (this.userInfoData.subscription) {
                subscriptionId = this.userInfoData.subscription.subscriptionId;
            }
            let DifferencePriceData = await _getDifferencePrice({
                groupName: this.$store.state.queryGroupName,
                subscriptionId,
            });
            if (DifferencePriceData.data.data) {
                this.differencePriceData = DifferencePriceData.data.data;
            }
        },
        handleCurrentAmount({ columns, data }) {
            const sums = {};
            columns.forEach((column, index) => {
                const key = column.key;
                if (index === 1) {
                    sums[key] = {
                        key,
                        value: this.$t("accountInfo.plan.totalText"),
                    };
                    return;
                }
                // const values = data.map(item => Number(item[key]));
                if (index === 4) {
                    // let totalPrice = this.paymentData[0].currentCharge.amount;
                    let totalPrice = 0;
                    data.forEach((e) => {
                        totalPrice += parseFloat(e.totalPrice);
                    });
                    // const v = values
                    //     .reduce((prev, curr) => {
                    //         const value = Number(curr);
                    //         if (!isNaN(value)) {
                    //             return prev + curr;
                    //         } else {
                    //             return prev;
                    //         }
                    //     }, 0)
                    //     .toFixed(3);
                    sums[key] = {
                        key,
                        value: `$ \n ${this.separator(totalPrice)} USD`,
                    };
                } else {
                    sums[key] = {
                        key,
                        value: "",
                    };
                }
            });

            return sums;
        },
        handleSummary({ columns, data }) {
            const sums = {};
            columns.forEach((column, index) => {
                const key = column.key;
                if (index === 0) {
                    sums[key] = {
                        key,
                        value: this.$t("accountInfo.plan.totalText"),
                    };
                    return;
                }
                const values = data.map((item) => Number(item[key]));
                if (index === 3) {
                    let totalPrice = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    totalPrice = totalPrice.toFixed(3);
                    sums[key] = {
                        key,
                        value: "≈ $ " + this.separator(totalPrice) + " USD",
                    };
                    this.costUsagePlanData.estimateCost = parseFloat(totalPrice);
                    this.reloadRouterView();
                } else {
                    sums[key] = {
                        key,
                        value: "",
                    };
                }
            });

            return sums;
        },
        async payInvoice() {
            this.payInvoiceLoading = true;
            let invoiceID = this.invoiceData;
            //- console.log(invoiceID);
            let payInvoiceResult = await _payInvoice({
                groupName: this.$store.state.queryGroupName,
                invoiceID,
            });
            if (payInvoiceResult.data.success) {
                this.$emit("reloadUserInfoData");
                this.$Message.success(this.$t("global.success"));
            } else {
                this.$Notice.warning({
                    title: this.$t("global.error"),
                    desc: payInvoiceResult.data.message,
                });
            }
            this.payInvoiceLoading = false;
        },
        async getPlan() {
            await this.getPaymentConfigs();
            const result = await getEsData(this.planInfoQuery);
            this.planColumns = result.data.mapData[0].planColumns;
            this.planColumns.forEach((e) => {
                let paymentConfig = this.paymentConfigs.find((config) => config._id == e.title);
                if (paymentConfig) {
                    e.title = this.$t("accountInfo." + e.title);
                }
            });
            this.planData = result.data.mapData[0].planData;
            this.planData.forEach((e) => {
                let paymentConfig = this.paymentConfigs
                    .filter((config) => config[e.id])
                    .map((item) => {
                        return { id: item._id, item: e.id, max: item[e.id], addPrice: item.addPrice[e.id] };
                    });
                if (paymentConfig.length > 0) {
                    let basicPaymentConfig = paymentConfig.find((item) => item.id == "basic");
                    e.basicContent = "";
                    basicPaymentConfig.addPrice.forEach((addPrice) => {
                        let illustrate = "";
                        let price = addPrice.price;
                        if (price.toString().includes("e-")) {
                            price = price.toFixed(7);
                        }
                        let max = addPrice.max;
                        let min = addPrice.min;
                        if (price == 0) {
                            illustrate = this.$t("accountInfo.contentFreeText");
                            price = "";
                        } else if (max == 999999999) {
                            illustrate = "/" + this.$t("accountInfo.contentText");
                            max = "∞";
                            price = "$" + price;
                        } else if (price > 0) {
                            price = "$" + price;
                        }
                        e.basicContent += `${this.separator(min)} - ${this.separator(max)}: ${this.separator(
                            price
                        )} ${illustrate};\n`;
                    });

                    let proPaymentConfig = paymentConfig.find((item) => item.id == "pro");
                    e.proContent = "";
                    proPaymentConfig.addPrice.forEach((addPrice) => {
                        let illustrate = "";
                        let price = addPrice.price;
                        if (price.toString().includes("e-")) {
                            price = price.toFixed(7);
                        }
                        let max = addPrice.max;
                        let min = addPrice.min;
                        if (price == 0) {
                            illustrate = this.$t("accountInfo.contentFreeText");
                            price = "";
                        } else if (max == 999999999) {
                            illustrate = "/" + this.$t("accountInfo.contentText");
                            max = "∞";
                            price = "$" + price;
                        } else if (price > 0) {
                            price = "$" + price;
                        }
                        e.proContent += `${this.separator(min)}-${this.separator(max)}: ${this.separator(
                            price
                        )} ${illustrate};\n`;
                    });
                }
            });
        },
        async getPaymentConfigs() {
            let search = {
                isFuzzySearch: false,
                esIndex: "rcm-payment-configs",
                from: 0,
                sort: [],
                filters: [],
                _source: [],
            };
            const result = await getEsData(search);
            this.paymentConfigs = result.data.mapData;
        },
        async getPaymentLog() {
            let date = new Date();
            let year = date.getFullYear();
            let mm = (date.getMonth() + 1).toString();
            let planInfoQuery = {
                isFuzzySearch: false,
                esIndex: "rcm-resource-usage-report-" + year + "." + mm.padStart(2, 0) + ".*",
                from: 0,
                sort: [],
                filters: [
                    {
                        key: "groupName",
                        type: "string",
                        value: this.$store.state.queryGroupName,
                    },
                ],
                _source: [],
                searchView: "PaymentEvent",
            };
            const result = await getEsData(planInfoQuery);
            this.userItmeLogData = result.data.mapData;
        },
        reloadRouterView() {
            this.isRouterAlive = false;
            this.$nextTick(() => {
                this.isRouterAlive = true;
            });
        },
        separator(numb) {
            var str = numb.toString().split(".");
            str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return str.join(".");
        },
    },
    computed: {
        description() {
            return this.userInfoData.subscription == undefined
                ? this.$t("accountInfo.plan.choosePlanText")
                : // : this.userInfoData.subscription.plan;
                  this.$t("accountInfo." + this.userInfoData.subscription.plan);
        },
        modalTitle() {
            switch (this.actionType) {
                case "add":
                    return this.$t("accountInfo.plan.selectPlanBtnText");
                    break;
                case "edit":
                    return this.$t("accountInfo.plan.changePlanBtnText");
                    break;
                case "showPlanDetail":
                    return this.$t("accountInfo.plan.planDetailText");
                    break;
                case "showPaymentDetail":
                    return this.$t("accountInfo.plan.paymentDetailText");
                    break;
                default:
                    break;
            }
        },
        getSubscriptionPeriodStart() {
            // subscriptionPeriodStart: new Date(this.$store.state.createDate),
            let toDay = new Date();
            let createDate = new Date(this.$store.state.createDate);
            return toDay.getMonth() == createDate.getMonth()
                ? new Date(this.$store.state.createDate)
                : new Date(toDay.getFullYear(), toDay.getMonth(), 1);
        },
    },
    created() {
        this.getPlanItems();
        this.action = this.actionType;
        this.getAmount();
        this.tableLoading = true;
        this.getHistoryData();
        if (this.userInfoData.subscription) {
            this.$store.commit("SET_USER_HAS_SUBSCRIPTION", true);
        } else {
            this.$store.commit("SET_USER_HAS_SUBSCRIPTION", false);
        }
        this.getDifferencePriceData();
        this.getPlan();
        this.getPaymentLog();
    },
};
</script>

<style lang="less" scoped>
.formItem {
    width: 100%;
}
.currentPlan {
    font-size: 8px;
}
.planCard {
    cursor: pointer;
    margin-bottom: 10px;
}
.cardPointer-active {
    border: 1px solid #00c08b;
}
</style>



// WEBPACK FOOTER //
// src/components/Payment/plan/listItem.vue